
export function cleanUpAnimation () {
    this.animationIn = null;
    this.animationOut = null;
    this.incomingView = '';
    // donot clear outgoing because it is set to the current view
}

async function animatePageTransition (gotoFunc) {
    
    const self = this;
    /*
    console.log(`animatePageTransition() incoming: ${this.incomingView} outgoing ${this.outgoingView}`);
    console.log('animatePageTransition() inFunc ', this.animationIn);
    console.log('animatePageTransition() outFunc ', this.animationOut);
    console.log('animatePageTransition() gotoFunc ');
    console.log(gotoFunc);
    */
    if (!this.animationIn || 
        !this.animationOut ||
        !this.incomingView ||
        !this.outgoingView
    ) {
        gotoFunc();
        return;
    }
    const p = new Promise ((resolve) => {
       function animate () {
        const inView = document.querySelector(`[name="${self.incomingView}"]`);
        const outView = document.querySelector(`[name="${self.outgoingView}"]`);
        if (!self.animationIn) {
            resolve();
            return;
        }
        self.animationIn({
            target: inView,
            duration: self.duration,
            onStart: () => {},
            onComplete: () => {
                gotoFunc();
                setTimeout(() => {
                    self.cleanUpAnimation();
                    self.removeViewFunc();
                }, 500);
                resolve();
            },
        });

        self.animationOut({
            target: outView,
            duration: self.duration,
        });
       }

       setTimeout(animate, 100);
    });

    return p;
}

export default animatePageTransition;
